import { Injectable } from '@angular/core';
import { ApiService } from "./api.service";
import { Storage } from "@ionic/storage";
import { DataService } from "./data.service";

@Injectable()

export class WorkorderService {

  constructor(
    public api: ApiService,
    public dataService: DataService,
    public storage: Storage
  ) {}

  public setWorkorder(record){
    let data = [record];
    console.log(data);
    return this.setWorkorders(data);
  }

  public setWorkorders(data, skip_existing_workorders?: boolean){
    // Set workorder
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('workorders_' + user_id).then((val) => {
          // if local storage already exists
          let workorders = (val ? JSON.parse(val) : []);
          for(let i = 0; i < data.length; i++){
            let record = data[i];
            // Set app_version_number
            record.app_version_number = this.dataService.getAppVersionNumber();
            // Set id
            if(!record._id) record._id = (record.workorder_id ? record.workorder_id : 'n' + new Date().getTime());
            // Add or update
            let found = false;
            for(let j = 0; j < workorders.length; j++){
              if(workorders[j]._id === record._id){
                found = true;
                if(!skip_existing_workorders || !workorders[j]['_status']){
                  // Overwrite record
                  workorders[j] = record;
                } else {
                  // Update date_planned, list_subtitle & daypart
                  if(record.time_planned && record.time_planned != workorders[j].time_planned){
                    workorders[j].time_planned = record.time_planned;
                    if(record.list_subtitle) workorders[j].list_subtitle = record.list_subtitle;
                  }
                  if(record.daypart) workorders[j].daypart = record.daypart;
                }
              }
            }
            if(!found){
              // Add record
              workorders.push(record);
            }
          }
          this.storage.set('workorders_' + user_id, JSON.stringify(workorders)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        }).catch(() => {
          // if local storage does not exist yet
          let workorders = data;
          this.storage.set('workorders_' + user_id, JSON.stringify(workorders)).then(() => {
            resolve();
          }).catch(() => {
            reject();
          });
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public getWorkorder(id){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('workorders_' + user_id).then((val) => {
          // if local storage already exists
          let workorders = (val ? JSON.parse(val) : []);
          let found = false;
          for(let j = 0; j < workorders.length; j++){
            if(workorders[j]._id == id){
              found = true;
              resolve(workorders[j]);
            }
          }
          if(!found){
            reject();
          }
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public deleteWorkorder(id){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('workorders_' + user_id).then((val) => {
          let workorders = (val ? JSON.parse(val) : []);
          let found = false;
          for(let j = 0; j < workorders.length; j++){
            if(workorders[j]._id == id){
              found = true;
              workorders.splice(j, 1);
            }
          }
          if(found){
            this.storage.set('workorders_' + user_id, JSON.stringify(workorders)).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public deleteWorkorders(data){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('workorders_' + user_id).then((val) => {
          let workorders = (val ? JSON.parse(val) : []);
          let changed = false;
          for(let i = 0; i < data.length; i++) {
            let record = data[i];
            for(let j = 0; j < workorders.length; j++){
              if(workorders[j]._id == record._id){
                changed = true;
                workorders.splice(j, 1);
              }
            }
          }
          if(changed){
            this.storage.set('workorders_' + user_id, JSON.stringify(workorders)).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          } else {
            reject();
          }
        }).catch(() => {
          reject();
        });
      }).catch(() => {
        reject();
      });
    });
  }

  public getWorkorders(){
    console.log('getWorkorders');
    return new Promise((resolve) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('workorders_' + user_id).then((val) => {
          let workorders = (val ? JSON.parse(val) : []);
          resolve(workorders);
        }).catch(() => {
          resolve([]);
        });
      }).catch(() => {
        resolve([]);
      });
    });
  }

  public sendCompletedWorkorders(){
    return new Promise((resolve, reject) => {
      this.storage.get('logged_in_user_id').then((user_id) => {
        this.storage.get('workorders_' + user_id).then((val) => {
          let workorders = (val ? JSON.parse(val) : []);
          let completed_workorders = [];
          for(let i = 0; i < workorders.length; i++){
            if(workorders[i]._status === 'done'){
              completed_workorders.push(workorders[i]);
            }
          }
          this.api.setWorkorders(completed_workorders).then(() => {
            this.deleteWorkorders(completed_workorders).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          }).catch(() => {
            reject();
          });
        });
      });
    });
  }

  public sendSelectedWorkorders(workorders){
    return new Promise((resolve, reject) => {
      let completed_workorders = [];
      for(let i = 0; i < workorders.length; i++){
        if(workorders[i]._status === 'done' && workorders[i]._selected){
          completed_workorders.push(workorders[i]);
        }
      }
      this.api.setWorkorders(completed_workorders).then(() => {
        this.deleteWorkorders(completed_workorders).then(() => {
          resolve();
        }).catch(() => {
          reject();
        });
      }).catch((error_code) => {
        reject(error_code);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/services/workorder.service.ts